import { BannerCard, Carousel } from '@design-system';

import { VideoStoryblok } from '../../../types/generated-storyblok';
import { StoryblokVideo } from '../../../types/Vimeo';
import {
  TrackCarouselSlide,
  TrackMultiMediaClick,
} from '../../../utils/analytics';
import { useBannerLabels } from '../../BannerV3/BannerEvent';
import PageSection from '../../Layout/PageSection';
import { ArtistVideo } from '../ArtistVideo';

const ArtistExclusiveEvent = ({
  analytics,
  item,
}: {
  analytics: Analytics;
  item: EventType;
}) => {
  const [{ active, text }] = useBannerLabels(
    item.link.story.content.startTime,
    item.link.story.content.endTime,
    item.overrideLabel,
  );

  return (
    <BannerCard
      as="a"
      aspectRatioClassName="aspect-[4/3]"
      description={item.overrideCategory || item.link.story.content.subtitle}
      href={`/${item.link.story.full_slug}`}
      image={item.overrideImage || item.link.story.content.image}
      onClick={() => {
        TrackMultiMediaClick({
          ...analytics,
          type: 'image',
          title: item.link.story.content.title,
        });
      }}
      pillIsActive={active || false}
      pillLabel={text || undefined}
      title={item.overrideHeadline || item.link.story.content.title}
      variant="image"
    />
  );
};

export const ArtistExclusive = ({
  analytics,
  items = [],
  title,
}: {
  analytics: Analytics;
  items: Array<EventType | StoryblokVideo | LinkCardImageComponent>;
  title: string;
}) => {
  return (
    <PageSection fullWidth>
      <Carousel
        headline={title}
        items={items.map((item) => {
          if (item.component === 'Video') {
            return (
              <ArtistVideo
                key={item._uid}
                analytics={analytics}
                blok={item as VideoStoryblok}
                coverImageSize={{
                  sm: { ratio: '4/3', span: 12 },
                  md: { ratio: '4/3', span: 6 },
                  lg: { ratio: '4/3', span: 6 },
                }}
              />
            );
          }

          if (item.component === 'event') {
            return (
              <ArtistExclusiveEvent
                key={item._uid}
                analytics={analytics}
                item={item}
              />
            );
          }

          if (item.component === 'linkCardImage') {
            return (
              <BannerCard
                key={item._uid}
                as="a"
                aspectRatioClassName="aspect-[4/3]"
                description={item.subtitle}
                href={item.link.url}
                image={item.image}
                onClick={() => {
                  TrackMultiMediaClick({
                    ...analytics,
                    type: 'image',
                    title: item.title,
                  });
                }}
                title={item.title}
                variant="image"
              />
            );
          }

          return null;
        })}
        onSlide={(index: number) => {
          TrackCarouselSlide({
            ...analytics,
            title,
            position: index,
            carouselLength: items.length,
          });
        }}
        perPage={2}
      />
    </PageSection>
  );
};
